import React from 'react';
import './settings.scss';

import { connect } from 'react-redux';
import { fetchSubscription } from '../../store/actions/subscriptionActions';
import { LEFT, RIGHT, UP, DOWN, BACK, ENTER } from '../../util/remoteButtons';
import { fireAnalytics } from '../../pages/utils';
import { fetchDevice, updateDevice } from '../../store/actions/deviceActions';
import {
  setShowLogo,
  setShowArtworkDetails,
  set4kQuality,
  setMute,
  setSwitchArtwork,
  setQR,
  setMatchContent,
} from '../../store/actions/settingActions';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navBar: false,
      mute: true,
      errorPopup: false,
      open: false,
      showLogo: true,
      highResolution: false,
      switch: false,
      showDetails: true,
      qr: this.props.setting.qr,
      isActive: false,
      selectedInterval: 'minutes',
      matchContent: false,
      styles: this.getStyles(),
    };
    this.selectedBtn = 'resolutionBase';
    this.selectedBtn1 = 'No';
    this.errorMessage = '';
   
    this.settingRef = React.createRef();
    this.resolutionRef = React.createRef();
    this.muteDeviceRef = React.createRef();
    this.showLogoRef = React.createRef();
    this.showDetailsRef = React.createRef();
    this.qrRef = React.createRef();
    this.contentRef = React.createRef();
    this.switchRef = React.createRef();
    this.intervalTimeRef = React.createRef();
    this.intervalOptionsRef = React.createRef();
    this.backBtnRef = React.createRef();
    this.minutesRef = React.createRef();
    this.secondsRef = React.createRef();
    this.hoursRef = React.createRef();

    // Switch elements
    this.muteOverlayRef = React.createRef();
    this.muteBaseRef = React.createRef();
    this.muteSwitchRef = React.createRef();
    this.logoOverlayRef = React.createRef();
    this.logoBaseRef = React.createRef();
    this.logoSwitchRef = React.createRef();
    this.contentSwitchRef = React.createRef();
    this.qrOverlayRef = React.createRef();
    this.qrBaseRef = React.createRef();
    this.qrSwitchRef = React.createRef();
    this.switchOverlayRef = React.createRef();
    this.switchBaseRef = React.createRef();
    this.switchSwitchRef = React.createRef();
    this.detailsOverlayRef = React.createRef();
    this.detailsBaseRef = React.createRef();
    this.detailsSwitchRef = React.createRef();
    this.resolutionOverlayRef = React.createRef();
    this.resolutionBaseRef = React.createRef();
    this.resolutionSwitchRef = React.createRef();

    // Dialog elements
    this.noRef = React.createRef();
    this.yesRef = React.createRef();

    // Navigation configuration
    this.navigationMap = {
      UP: {
        'MuteBase': () => this.navigateToResolution(),
        'MuteOverlay': () => this.navigateToResolution(),
        'LogoBase': () => this.navigateToMute(),
        'LogoOverlay': () => this.navigateToMute(),
        'detailsBase': () => this.navigateToLogo(),
        'detailsOverlay': () => this.navigateToLogo(),
        'qrBase': () => this.navigateToDetails(),
        'qrOverlay': () => this.navigateToDetails(),
        'contentBase': () => this.navigateToQr(),
        'contentOverlay': () => this.navigateToQr(),
        'switchBase': () => this.navigateToContent(),
        'switchOverlay': () => this.navigateToContent(),
        'IntervalTime': () => this.incrementInterval(),
        'IntervalOptions': () => this.navigateToSwitch(),
        'Back': () => this.navigateToIntervalOptions(),
        'minutes': () => this.navigateToSeconds(),
        'hours': () => this.navigateToMinutes()
      },
      DOWN: {
        'resolutionBase': () => this.navigateToMute(),
        'resolutionOverlay': () => this.navigateToMute(),
        'MuteBase': () => this.navigateToLogo(),
        'MuteOverlay': () => this.navigateToLogo(),
        'LogoBase': () => this.navigateToDetails(),
        'LogoOverlay': () => this.navigateToDetails(),
        'detailsBase': () => this.navigateToQr(),
        'detailsOverlay': () => this.navigateToQr(),
        'qrBase': () => this.navigateToContent(),
        'qrOverlay': () => this.navigateToContent(),
        'contentBase': () => this.navigateToSwitch(),
        'contentOverlay': () => this.navigateToSwitch(),
        'switchBase': () => this.navigateToIntervalOptions(),
        'switchOverlay': () => this.navigateToIntervalOptions(),
        'IntervalTime': () => this.decrementInterval(),
        'IntervalOptions': () => this.navigateToBack(),
        'seconds': () => this.navigateToMinutes(),
        'minutes': () => this.navigateToHours()
      }
    };

    // Switch actions configuration
    this.switchActions = {
      'MuteBase': () => this.toggleMute(true),
      'MuteOverlay': () => this.toggleMute(false),
      'LogoBase': () => this.toggleLogo(true),
      'LogoOverlay': () => this.toggleLogo(false),
      'contentBase': () => this.toggleContent(true),
      'contentOverlay': () => this.toggleContent(false),
      'qrBase': () => this.toggleQr(true),
      'qrOverlay': () => this.toggleQr(false),
      'switchBase': () => this.toggleSwitch(true),
      'switchOverlay': () => this.toggleSwitch(false),
      'detailsBase': () => this.toggleDetails(true),
      'detailsOverlay': () => this.toggleDetails(false),
      'resolutionBase': () => this.toggleResolution(true),
      'resolutionOverlay': () => this.toggleResolution(false)
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentWillMount() {
    if (this.props.setting.mute) this.setState({ mute: true });
    if (this.props.setting.qr) this.setState({ qr: true });
    if (this.props.setting.showLogo) this.setState({ showLogo: true });
    if (this.props.setting.showArtworkDetails) this.setState({ showDetails: true });
    if (this.props.setting.switchArtwork) this.setState({ switch: true });
    if (this.props.setting.quality4k) this.setState({ highResolution: true });
    this.props.setting.matchContent ? this.setState({ matchContent: true }) : this.setState({ matchContent: false })
  }

  async componentDidMount() {
    setTimeout(() => {
      this.settingRef?.current && this.settingRef.current.focus();
    }, 300);
    fireAnalytics('Page', 'Settings Page Loaded');

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    setTimeout(() => {
      if (this.props.setting.mute) {
        this.muteOverlayRef.current.style.display = 'block';
        this.muteBaseRef.current.style.display = 'none';
        this.muteSwitchRef.current.style.left = 'auto';
        this.muteSwitchRef.current.style.right = 0;
        this.setState({
          mute: true,
        });
      }
      if (this.props.setting.showLogo) {
        this.logoOverlayRef.current.style.display = 'block';
        this.logoBaseRef.current.style.display = 'none';
        this.logoSwitchRef.current.style.left = 'auto';
        this.logoSwitchRef.current.style.right = 0;
        this.setState({ showLogo: true });
      }
      if (this.props.setting.showArtworkDetails) {
        this.detailsOverlayRef.current.style.display = 'block';
        this.detailsBaseRef.current.style.display = 'none';
        this.detailsSwitchRef.current.style.left = 'auto';
        this.detailsSwitchRef.current.style.right = 0;
        this.setState({ showDetails: true });
      }
      if (this.props.setting.qr) {
        this.qrOverlayRef.current.style.display = 'block';
        this.qrBaseRef.current.style.display = 'none';
        this.qrSwitchRef.current.style.left = 'auto';
        this.qrSwitchRef.current.style.right = 0;
        this.setState({ qr: true });
      }
      if (this.props.setting.switchArtwork) {
        this.switchOverlayRef.current.style.display = 'block';
        this.switchBaseRef.current.style.display = 'none';
        this.switchSwitchRef.current.style.left = 'auto';
        this.switchSwitchRef.current.style.right = 0;
        this.setState({ switch: true });
      }
      if (this.props.setting.quality4k) {
        this.resolutionOverlayRef.current.style.display = 'block';
        this.resolutionBaseRef.current.style.display = 'none';
        this.resolutionSwitchRef.current.style.left = 'auto';
        this.resolutionSwitchRef.current.style.right = 0;
        this.selectedBtn = 'resolutionOverlay';
        this.setState({ highResolution: true });
      }
      if (this.props.setting.matchContent) {
        this.contentSwitchRef.current.style.left = 'auto';
        this.contentSwitchRef.current.style.right = 0;
      }
      if (this.props.device.data.interval <= 60000) {
        this.intervalTimeRef.current.value = Math.floor(this.props.device.data.interval / 1000);
        this.setState({
          selectedInterval: 'seconds'
        })
      } else if (this.props.device.data.interval <= 3600000) {
        this.intervalTimeRef.current.value = Math.floor(this.props.device.data.interval / 60000);
        this.setState({
          selectedInterval: 'minutes'
        })
      } else {
        this.intervalTimeRef.current.value = Math.floor(this.props.device.data.interval / 3600000);
        this.setState({
          selectedInterval: 'hours'
        })
      }
    }, 200);
  }

  // Helper methods for class management
  addActiveClass = (ref) => {
    if (ref?.current) {
      ref.current.classList.add('settingsActiveElement');
    }
  };
  
  removeActiveClass = (ref) => {
    if (ref?.current) {
      ref.current.classList.remove('settingsActiveElement');
    }
  };
  
  focusElement = (ref) => {
    if (ref?.current) {
      ref.current.focus();
    }
  };
  
  blurElement = (ref) => {
    if (ref?.current) {
      ref.current.blur();
    }
  };
  
  // Navigation methods
  navigateToResolution = () => {
    this.addActiveClass(this.resolutionRef);
    this.removeActiveClass(this.muteDeviceRef);
    this.focusElement(this.resolutionRef);
    this.selectedBtn = this.state.highResolution ? 'resolutionOverlay' : 'resolutionBase';
  };
  
  navigateToMute = () => {
    this.addActiveClass(this.muteDeviceRef);
    this.removeActiveClass(this.resolutionRef);
    this.removeActiveClass(this.showLogoRef);
    this.focusElement(this.muteDeviceRef);
    this.selectedBtn = this.state.mute ? 'MuteOverlay' : 'MuteBase';
  };
  
  navigateToLogo = () => {
    this.addActiveClass(this.showLogoRef);
    this.removeActiveClass(this.muteDeviceRef);
    this.removeActiveClass(this.showDetailsRef);
    this.focusElement(this.showLogoRef);
    this.selectedBtn = this.state.showLogo ? 'LogoOverlay' : 'LogoBase';
  };
  
  navigateToDetails = () => {
    this.addActiveClass(this.showDetailsRef);
    this.focusElement(this.showDetailsRef);
    this.removeActiveClass(this.showLogoRef);
    this.removeActiveClass(this.qrRef);
    this.selectedBtn = this.state.showDetails ? 'detailsOverlay' : 'detailsBase';
  };
  
  navigateToQr = () => {
    this.addActiveClass(this.qrRef);
    this.removeActiveClass(this.showDetailsRef);
    this.removeActiveClass(this.contentRef);
    this.focusElement(this.qrRef);
    this.selectedBtn = this.state.qr ? 'qrOverlay' : 'qrBase';
  };
  
  navigateToContent = () => {
    this.addActiveClass(this.contentRef);
    this.removeActiveClass(this.qrRef);
    this.removeActiveClass(this.switchRef);
    this.focusElement(this.contentRef);
    this.selectedBtn = this.state.matchContent ? 'contentOverlay' : 'contentBase';
  };
  
  navigateToSwitch = () => {
    this.addActiveClass(this.switchRef);
    this.removeActiveClass(this.contentRef);
    this.removeActiveClass(this.intervalOptionsRef);
    this.focusElement(this.switchRef);
    this.selectedBtn = this.state.switch ? 'switchBase' : 'switchOverlay';
  };
  
  navigateToIntervalOptions = () => {
    this.addActiveClass(this.intervalOptionsRef);
    this.removeActiveClass(this.switchRef);
    this.removeActiveClass(this.backBtnRef);
    this.focusElement(this.intervalOptionsRef);
    this.selectedBtn = 'IntervalOptions';
  };
  
  navigateToBack = () => {
    this.addActiveClass(this.backBtnRef);
    this.removeActiveClass(this.intervalOptionsRef);
    this.focusElement(this.backBtnRef);
    this.selectedBtn = 'Back';
  };
  
  navigateToSeconds = () => {
    this.focusElement(this.secondsRef);
    this.removeActiveClass(this.minutesRef);
    this.addActiveClass(this.secondsRef);
    this.selectedBtn = 'seconds';
  };
  
  navigateToMinutes = () => {
    this.focusElement(this.minutesRef);
    this.removeActiveClass(this.secondsRef);
    this.removeActiveClass(this.hoursRef);
    this.addActiveClass(this.minutesRef);
    this.selectedBtn = 'minutes';
  };
  
  navigateToHours = () => {
    this.focusElement(this.hoursRef);
    this.removeActiveClass(this.minutesRef);
    this.addActiveClass(this.hoursRef);
    this.selectedBtn = 'hours';
  };
  
  // Interval management
  incrementInterval = () => {
    const val = parseInt(this.intervalTimeRef.current?.value || '0');
    if (val < 59) {
      this.intervalTimeRef.current.value = val + 1;
    } else {
      this.showError('Value Cannot Exceed 59');
    }
  };
  
  decrementInterval = () => {
    const val = parseInt(this.intervalTimeRef.current?.value || '0');
    if (val > 1) {
      this.intervalTimeRef.current.value = val - 1;
    } else {
      this.showError('Value Cannot be 0');
    }
  };
  
  // Switch toggle methods
  toggleMute = async (enable) => {
    const response = await this.props.updateDevice(this.props.device.data.id, 'mute', !this.state.mute);
    if (response.success) {
      this.props.updateMute(!this.state.mute);
      this.setState({ mute: !this.state.mute });
      
      if (enable) {
        this.muteOverlayRef.current.style.display = 'block';
        this.muteBaseRef.current.style.display = 'none';
        this.muteSwitchRef.current.style.left = 'auto';
        this.muteSwitchRef.current.style.right = '0';
        this.selectedBtn = 'MuteOverlay';
      } else {
        this.muteBaseRef.current.style.display = 'block';
        this.muteOverlayRef.current.style.display = 'none';
        this.muteSwitchRef.current.style.left = '0';
        this.muteSwitchRef.current.style.right = 'auto';
        this.selectedBtn = 'MuteBase';
      }
      await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    }
  };
  
  toggleLogo = async (enable) => {
    const response = await this.props.updateDevice(this.props.device.data.id, 'logo', !this.state.logo);
    if (response.success) {
      this.setState({ logo: !this.state.logo });
      
      if (enable) {
        this.logoOverlayRef.current.style.display = 'block';
        this.logoBaseRef.current.style.display = 'none';
        this.logoSwitchRef.current.style.left = 'auto';
        this.logoSwitchRef.current.style.right = '0';
        this.selectedBtn = 'LogoOverlay';
      } else {
        this.logoBaseRef.current.style.display = 'block';
        this.logoOverlayRef.current.style.display = 'none';
        this.logoSwitchRef.current.style.left = '0';
        this.logoSwitchRef.current.style.right = 'auto';
        this.selectedBtn = 'LogoBase';
      }
      
      this.props.updateShowLogo(enable);
      await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    }
  };
  
  toggleContent = async (enable) => {
    const response = await this.props.updateDevice(this.props.device.data.id, 'content', !this.state.matchContent);
    if (response.success) {
      this.setState({ matchContent: !this.state.matchContent });
      
      this.contentSwitchRef.current.style.left = enable ? 'auto' : '0';
      this.contentSwitchRef.current.style.right = enable ? '0' : 'auto';
      this.selectedBtn = enable ? 'contentOverlay' : 'contentBase';
      
      this.props.updateMatchContent(enable);
      await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    }
  };
  
  toggleQr = async (enable) => {
    const response = await this.props.updateDevice(this.props.device.data.id, 'qr', !this.state.qr);
    if (response.success) {
      this.setState({ qr: !this.state.qr });
      
      if (enable) {
        this.qrOverlayRef.current.style.display = 'block';
        this.qrBaseRef.current.style.display = 'none';
      } else {
        this.qrBaseRef.current.style.display = 'block';
        this.qrOverlayRef.current.style.display = 'none';
      }
      
      this.qrSwitchRef.current.style.left = enable ? 'auto' : '0';
      this.qrSwitchRef.current.style.right = enable ? '0' : 'auto';
      this.selectedBtn = enable ? 'qrOverlay' : 'qrBase';
      
      this.props.updateQR(enable);
      await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    }
  };
  
  toggleSwitch = (enable) => {
    if (enable) {
      this.switchOverlayRef.current.style.display = 'block';
      this.switchBaseRef.current.style.display = 'none';
    } else {
      this.switchBaseRef.current.style.display = 'block';
      this.switchOverlayRef.current.style.display = 'none';
    }
    
    this.switchSwitchRef.current.style.left = enable ? 'auto' : '0';
    this.switchSwitchRef.current.style.right = enable ? '0' : 'auto';
    this.selectedBtn = enable ? 'switchOverlay' : 'switchBase';
    
    this.props.updateSwitchArtwork(enable);
  };
  
  toggleDetails = async (enable) => {
    const response = await this.props.updateDevice(this.props.device.data.id, 'details', !this.state.showDetails);
    if (response.success) {
      if (enable) {
        this.detailsOverlayRef.current.style.display = 'block';
        this.detailsBaseRef.current.style.display = 'none';
      } else {
        this.detailsBaseRef.current.style.display = 'block';
        this.detailsOverlayRef.current.style.display = 'none';
      }
      
      this.detailsSwitchRef.current.style.left = enable ? 'auto' : '0';
      this.detailsSwitchRef.current.style.right = enable ? '0' : 'auto';
      this.selectedBtn = enable ? 'detailsOverlay' : 'detailsBase';
      
      this.props.updateShowArtDetails(enable);
      await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    }
  };
  
  toggleResolution = async (enable) => {
    const response = await this.props.updateDevice(this.props.device.data.id, 'highQuality', !this.state.highResolution);
    if (response.success) {
      this.setState({ highResolution: !this.state.highResolution });
      
      if (enable) {
        this.resolutionOverlayRef.current.style.display = 'block';
        this.resolutionBaseRef.current.style.display = 'none';
      } else {
        this.resolutionBaseRef.current.style.display = 'block';
        this.resolutionOverlayRef.current.style.display = 'none';
      }
      
      this.resolutionSwitchRef.current.style.left = enable ? 'auto' : '0';
      this.resolutionSwitchRef.current.style.right = enable ? '0' : 'auto';
      this.selectedBtn = enable ? 'resolutionOverlay' : 'resolutionBase';
      
      this.props.updateQuality(enable);
      await this.props.fetchDevice(this.props.app.SCAPDeviceId);
    }
  }
  
  // Error handling
  showError = (message) => {
    this.errorMessage = message;
    this.setState({ errorPopup: true });
    setTimeout(() => {
      this.setState({ errorPopup: false });
    }, 3000);
  };
  
  // Save settings
  saveSettings = async () => {
    const selectedOption = this.state.selectedInterval;
    const multiplier = { seconds: 1000, minutes: 60000, hours: 3600000 };
    const interval = parseInt(this.intervalTimeRef.current?.value || '0') * multiplier[selectedOption];
    
    if (interval !== this.props.device.data.interval) {
      const response = await this.props.updateDevice(this.props.device.data.id, 'interval', interval);
      this.errorMessage = response.success ? 'Settings Updated Successfully' : 'Unable to Save Settings';
      this.setState({ errorPopup: true });
      await this.props.fetchDevice(this.props.app.SCAPDeviceId);
      setTimeout(() => {
        this.setState({ errorPopup: false });
        this.props.onClose();
      }, 3000);
    } else {
      this.errorMessage = 'Settings updated successfully';
      this.setState({ errorPopup: true });
      setTimeout(() => {
        this.setState({ errorPopup: false });
        this.props.onClose();
      }, 3000);
    }
  };
  
  // Handle interval selection
  handleIntervalSelection = (interval) => {
    this.blurElement(this[`${this.selectedBtn}Ref`]);
    this.addActiveClass(this.intervalOptionsRef);
    this.removeActiveClass(this[`${this.selectedBtn}Ref`]);
    this.focusElement(this.intervalOptionsRef);
    this.selectedBtn = 'IntervalOptions';
    this.setState({ selectedInterval: interval, isActive: false });
  };
  
  // Optimized main handler
  async handleKeyDown(e) {
    e.stopPropagation();
    e.preventDefault();
  
    switch (e.keyCode) {
      case UP:
        const upAction = this.navigationMap.UP[this.selectedBtn];
        if (upAction) upAction();
        break;
    
      case 27:
      case BACK:
        if (this.state.open) {
          this.setState({ open: false });
        } else {
          await this.saveSettings();
        }
        break;
      
      case ENTER:
        if (this.state.open) {
          if (this.selectedBtn1 === 'No') {
            this.setState({ open: false });
          } else if (this.selectedBtn1 === 'Yes') {
            window.open('', '_self').close();
          }
        } else {
          const switchAction = this.switchActions[this.selectedBtn];
          if (switchAction) {
            await switchAction();
          } else if (this.selectedBtn === 'Back') {
            await this.saveSettings();
          } else if (this.selectedBtn === 'IntervalOptions') {
            this.setState({ isActive: true }, () => {
              this.focusElement(this.secondsRef);
              this.removeActiveClass(this.intervalOptionsRef);
              this.addActiveClass(this.secondsRef);
              this.selectedBtn = 'seconds';
            });
          } else if (['seconds', 'minutes', 'hours'].includes(this.selectedBtn)) {
            this.handleIntervalSelection(this.selectedBtn);
          }
        }
        break;
      
      case DOWN:
        const downAction = this.navigationMap.DOWN[this.selectedBtn];
        if (downAction) downAction();
        break;
      
      case RIGHT:
        if (this.state.open) {
          this.noRef.current.style.background = '';
          this.yesRef.current.style.background = '#910048';
          this.selectedBtn1 = 'Yes';
        } else if (this.selectedBtn === 'IntervalTime') {
          this.focusElement(this.settingRef);
          this.addActiveClass(this.intervalOptionsRef);
          this.removeActiveClass(this.intervalTimeRef);
          this.selectedBtn = 'IntervalOptions';
        }
        break;
      
      case LEFT:
        if (this.state.open) {
          this.yesRef.current.style.background = '';
          this.noRef.current.style.background = '#910048';
          this.selectedBtn1 = 'No';
        } else if (this.selectedBtn === 'IntervalOptions') {
          this.focusElement(this.settingRef);
          this.addActiveClass(this.intervalTimeRef);
          this.removeActiveClass(this.intervalOptionsRef);
          this.selectedBtn = 'IntervalTime';
        }
        break;
      
      case EXIT:
        if (this.state.open) {
          this.setState({ open: false });
        } else {
          this.setState({ open: !this.state.open });
          this.selectedBtn1 = 'No';
        }
        break;
      
      default:
        break;
    }
  }

  getStyles = () => {
    const isPortrait = window.innerWidth <= window.innerHeight;
    return {
      settingHeight: isPortrait ? '56%' : '89%',
      padding: isPortrait ? '3%' : '1%',
      footerHeight: isPortrait ? '120px' : '95px',
      footerFontSize: isPortrait ? '1.8rem' : '1.5rem'
    };
  };

  handleResize = () => {
    this.setState({ styles: this.getStyles() });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const { styles } = this.state;
    return (
      <div
        className="settings"
        style={{
          height: styles.settingHeight,
        }}
        ref={this.settingRef}
        onKeyDown={this.handleKeyDown}
        tabIndex={10}
      >
        <h3 
          className="account__header"
          style={{
            display: (window.innerWidth === 3840 && window.innerHeight === 1080) ? 'none' : 'block',
          }}
          >Settings</h3>

        <div className="settings__leftWrapper">
          <div className="settings__leftWrapper_resolution-Wrapper">
            <div className="settings__leftWrapper_resolution-Wrapper_text">4K Resolution</div>
            <div id="resolution" ref={this.resolutionRef} className="settings__leftWrapper_resolution-Wrapper_images settingsActiveElement">
              <img
                id="resolutionBase"
                ref={this.resolutionBaseRef}
                className="settings__leftWrapper_resolution-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="resolutionOverlay"
                ref={this.resolutionOverlayRef}
                className="settings__leftWrapper_resolution-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="resolutionSwitch"
                ref={this.resolutionSwitchRef}
                className="settings__leftWrapper_resolution-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="settings__leftWrapper_muteDevice-Wrapper">
            <div className="settings__leftWrapper_muteDevice-Wrapper_text">Mute Device</div>
            <div id="muteDevice" ref={this.muteDeviceRef} className="settings__leftWrapper_muteDevice-Wrapper_images ">
              <img
                id="muteBase"
                ref={this.muteBaseRef}
                className="settings__leftWrapper_muteDevice-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="muteOverlay"
                ref={this.muteOverlayRef}
                className="settings__leftWrapper_muteDevice-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="muteSwitch"
                ref={this.muteSwitchRef}
                className="settings__leftWrapper_muteDevice-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="settings__leftWrapper_showLogo-Wrapper">
            <div className="settings__leftWrapper_showLogo-Wrapper_text">Show Logo</div>
            <div id="showLogo" ref={this.showLogoRef} className="settings__leftWrapper_showLogo-Wrapper_images">
              <img
                id="logoBase"
                ref={this.logoBaseRef}
                className="settings__leftWrapper_showLogo-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="logoOverlay"
                ref={this.logoOverlayRef}
                className="settings__leftWrapper_showLogo-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="logoSwitch"
                ref={this.logoSwitchRef}
                className="settings__leftWrapper_showLogo-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="settings__leftWrapper_showDetails-Wrapper">
            <div className="settings__leftWrapper_showDetails-Wrapper_text">Always Show Artwork Details</div>
            <div id="showDetails" ref={this.showDetailsRef} className="settings__leftWrapper_showDetails-Wrapper_images">
              <img
                id="detailsBase"
                ref={this.detailsBaseRef}
                className="settings__leftWrapper_showDetails-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="detailsOverlay"
                ref={this.detailsOverlayRef}
                className="settings__leftWrapper_showDetails-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="detailsSwitch"
                ref={this.detailsSwitchRef}
                className="settings__leftWrapper_showDetails-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>
          <div className="settings__leftWrapper_qr-Wrapper">
            <div className="settings__leftWrapper_qr-Wrapper_text">Show QR</div>
            <div id="qr" ref={this.qrRef} className="settings__leftWrapper_qr-Wrapper_images">
              <img
                id="qrBase"
                ref={this.qrBaseRef}
                className="settings__leftWrapper_qr-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="qrOverlay"
                ref={this.qrOverlayRef}
                className="settings__leftWrapper_qr-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="qrSwitch"
                ref={this.qrSwitchRef}
                className="settings__leftWrapper_qr-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="settings__leftWrapper_content-Wrapper">
            <div className="settings__leftWrapper_content-Wrapper_text">Match Content</div>
            <div id="content" ref={this.contentRef} className="settings__leftWrapper_content-Wrapper_images">
              {this.state.matchContent ? <img
                id="contentOverlay"
                className="settings__leftWrapper_content-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              /> : <img
                id="contentBase"
                className="settings__leftWrapper_content-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              }
              <img
                id="contentSwitch"
                ref={this.contentSwitchRef}
                className="settings__leftWrapper_content-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="settings__leftWrapper_switch-Wrapper">
            <div className="settings__leftWrapper_switch-Wrapper_text">Switch Artwork</div>
            <div id="switch" ref={this.switchRef} className="settings__leftWrapper_switch-Wrapper_images">
              <img
                id="switchBase"
                ref={this.switchBaseRef}
                className="settings__leftWrapper_switch-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="switchOverlay"
                ref={this.switchOverlayRef}
                className="settings__leftWrapper_switch-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="switchSwitch"
                ref={this.switchSwitchRef}
                className="settings__leftWrapper_switch-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="settings__leftWrapper_switchArtwork-Wrapper">
            <div className="settings__leftWrapper_switchArtwork-Wrapper_text">Switch Artwork Every</div>
            <div className="settings__leftWrapper_switchArtwork-Wrapper_images">
              <input type="text" id="intervalTime" ref={this.intervalTimeRef} name="intervalTime" />

              <div>
                <button
                  name="intervalOptions" id="intervalOptions" ref={this.intervalOptionsRef}
                >
                  {this.state.selectedInterval}
                </button>
                {this.state.isActive && (
                  <nav
                    style={{ position: 'absolute', display: 'flex', flexDirection: "column", top: '2rem', background: '#222' }}
                  >
                    <button
                      ref={this.secondsRef}
                      id="seconds"
                      name="seconds"
                      className='menuItem'
                    >
                      Seconds
                    </button>
                    <button
                      ref={this.minutesRef}
                      id="minutes"
                      className='menuItem'
                    >
                      Minutes
                    </button>
                    <button
                      ref={this.hoursRef}
                      id="hours"
                      className='menuItem'
                    >
                      Hours
                    </button>

                  </nav>
                )}
              </div>
            </div>
          </div>
          <div className="settings__leftWrapper_backBtn-Wrapper">
            <div
              className="settings__leftWrapper_backBtn-Wrapper_text"
              style={{
                padding: styles.padding,
              }}
              id="backBtn"
              ref={this.backBtnRef}
            >
              Back
            </div>
          </div>
        </div>

        <div
          className="account__footer"
          style={{
            height: styles.footerHeight,
            fontSize: styles.footerFontSize,
          }}
        >
          For help contact: <strong>support@blackdove.com</strong>
        </div>

        <div className="timedPopup" style={!this.state.errorPopup ? { opacity: '0' } : { opacity: '1' }}>
          {this.errorMessage}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateDevice: (deviceId, updateVal, value) => dispatch(updateDevice(deviceId, updateVal, value)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchSubscription: () => dispatch(fetchSubscription()),
  updateMute: (val) => dispatch(setMute(val)),
  updateShowLogo: (val) => dispatch(setShowLogo(val)),
  updateShowArtDetails: (val) => dispatch(setShowArtworkDetails(val)),
  updateQR: (val) => dispatch(setQR(val)),
  updateSwitchArtwork: (val) => dispatch(setSwitchArtwork(val)),
  updateQuality: (val) => dispatch(set4kQuality(val)),
  updateMatchContent: (val) => dispatch(setMatchContent(val)),
});
export default connect((state) => {
  const { app, subscription, device, setting } = state;
  return {
    app,
    subscription,
    device,
    setting,
  };
}, mapDispatchToProps)(Settings);
